import axios from "axios";
import { getToken } from "services/Auth";

// Alinhado ao beedoo-front: base URL da API de notificação (canais/chat).
// Pode ser URL absoluta (ex.: https://apiqa-notification.beedoo.io) ou path do proxy (ex.: /notification-api).
// Se só REACT_APP_NOTIFICATION_API_PROXY_TARGET estiver definido, usa /notification-api para o proxy.
const getNotificationBaseURL = () => {
  const url =
    process.env.REACT_APP_NOTIFICATION_API_URL ||
    (process.env.REACT_APP_NOTIFICATION_API_PROXY_TARGET
      ? "/notification-api"
      : "http://localhost:8001");
  return typeof url === "string" ? url.replace(/\/$/, "") : url;
};

const NotificationApiService = axios.create({
  baseURL: getNotificationBaseURL(),
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

NotificationApiService.interceptors.request.use(
  function (config) {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default NotificationApiService;
